import {
  EBaseButtonSize,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { getSportsbookDemo, IApplicationState } from '@spinwise/spinwise-core';
import axios from 'axios';
import classNames from 'classnames';
import GuestHeader from 'Components/shared/Header/state/GuestHeaderFront.component';
import { t } from 'i18next';
import { EBrandButtonTypes } from 'Libraries/buttons.library';
import { PATHS } from 'Libraries/routes.library';
import Link from 'Components/shared/Link/Link';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { EPromoSlugs, ETitles } from 'Types/globals';
import { openPromoModal } from 'Utils/modals';
import ReplayCarousel from './ReplayCarousel';
import BottomCard from './BottomCard';
import styles from './GuestHomepageSport.module.scss';
import TopWelcomeBlockSport from './TopWelcomeBlockSport';
import * as gtag from '../../../lib/gtag';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import { EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { IconArrowRight } from '@spinwise/react-component-library/IconArrowRight';
import Payments from '../GuestHomepage/Payments/Payments';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

export interface IGuestHomepageSportProps {
  player_type: any;
  theme: any;
  regtype: any;
  payment_methods: any;
  dynamic_welcome_package?: any;
  sport_landing?: any;
  titles?: Record<ETitles, string>;
}

const GuestHomepageSport = ({
  player_type,
  dynamic_welcome_package,
  payment_methods,
  regtype,
  theme,
  sport_landing,
  titles,
}: IGuestHomepageSportProps) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const reg_type = useSelector((state: IApplicationState) => state.globalReducer.geo.reg_type);
  const geoSportsbook = useSelector((state: IApplicationState) => state.globalReducer.geo.sportsbook);
  const currentLanguage = useSelector((state: IApplicationState) => state.globalReducer?.currentLanguage);
  const [regType, SetRegType] = useState(regtype);
  const betby_keyword = sport_landing?.[0]?.betby_keyword ?? null;

  const showRegisterButton = useShowAuthButtons();

  useEffect(() => {
    if (reg_type && reg_type !== regType) {
      SetRegType(reg_type);
    }
  }, [reg_type, regType]);
  const [navIsTransparent, setNavIsTransparent] = useState(false);
  const handleScroll = e => {
    if (document.scrollingElement.scrollTop >= 30) {
      setNavIsTransparent(false);
    } else {
      setNavIsTransparent(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    setNavIsTransparent(true);
    // setPageLoading(false);

    gtag?.event?.('sportsbook-landing-opened', {
      category: 'Pages',
      label: 'visited guest sport page',
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const bottomCardC = dynamic_welcome_package?.map(el => {
    return {
      title: el.title ?? '',
      subtitle: el.subtitle ?? '',
      description: el.description ?? '',
      number: el.rank ?? 0,
      image: el.image?.data?.attributes?.url ?? '',
      buttonComponent:
        (el.rank == 1 || el.rank == null) && showRegisterButton ? (
          <Link href={PATHS.REGISTER} className="w-100">
            <ButtonTextOnly
              label={t('homepage.c2.create.account.btn')}
              type={EBrandButtonTypes.Tertiary}
              size={EBaseButtonSize.Medium}
              textSize={EBaseTextSize.Large}
              fullWidth={true}
              textWeight={EBaseTextWeight.W500}
              alignText={EButtonTextAlign.Center}
              borderRadius={EButtonBorderRadiusStrength.Seven}
            />
          </Link>
        ) : null,
    };
  });
  // #region sport
  const { sportsbook, loading, success, loaded } = useSelector((state: IApplicationState) => state.sportsbookReducer);
  const sportsFrame = useRef();
  useEffect(() => {
    getSport();
  }, [geoSportsbook?.urlKey]);
  const getSport = () => {
    if (geoSportsbook?.urlKey && !sportsbook) {
      const payload = {
        urlKey: geoSportsbook?.urlKey,
        openMobile: false,
      };
      getSportsbookDemo(payload)(dispatch);
    }
  };
  useEffect(() => {
    // second enter
    if (window.bt && !scriptLoaded) {
      if (sportsbook) {
        setScriptLoaded(true);
        return;
      }
      getSport();
    }
  }, [sportsFrame?.current]);

  useEffect(() => {
    if (window.bt && !scriptLoaded && sportsbook) {
      setScriptLoaded(true);
    }

    return () => {
      if (window?.widgetInstance) {
        window?.widgetInstance?.kill();
      }
    };
  }, [sportsbook]);

  const initSportCarousel = () => {
    window.bt = window.bt ?? new window.BTRenderer();
    window.widgetInstance = window.bt?.initialize({
      // Brand id
      brand_id: `${sportsbook?.jsParams?.brandId}`,
      // User token
      token: sportsbook?.jsParams?.token ? `${sportsbook?.jsParams?.token}` : null,
      onTokenExpired: async () => {
        const res = (await axios.get(`/api/sportsbook/refresh?urlKey=${sportsbook?.urlKey}&openMobile=false`)) as any;
        return res?.data?.token;
      },
      // Language
      lang: 'en',
      // Dom node for widget
      target: sportsFrame?.current,
      // Theme name provided by our team
      themeName: 'default',
      // Widget name:
      widgetName: 'promo',
      // Params specific to widget
      widgetParams: {
        // placeholder name from backoffice
        placeholder: betby_keyword ? betby_keyword : 'sport_page', // keyword strapi
        // callback to change url when user clicks on banner
        onBannerClick: args => {
          router.push(PATHS.SPORTS);
        },
      },
    });
    if (scriptLoaded == false) setScriptLoaded(true);
  };
  useEffect(() => {
    if (scriptLoaded == false) return;
    initSportCarousel();
  }, [scriptLoaded]);
  const GuestHomepageSportFooterSlot = () => {
    return (
      <>
        <div className={styles.footer_page_element}>
          <div className={styles.footer_page_element_inner}>
            <div className={styles.footer_left_container}>
              <div className={styles.footer_text_container}>
                <p className={styles.footer_title}>
                  <Trans components={{}} transKeepBasicHtmlNodesFor>
                    {t('homepage.sport.bottom.blue.title')}
                  </Trans>
                </p>
                <p className={styles.footer_subtitle}>{t('homepage.sport.bottom.blue.subtitle')}</p>
              </div>
              {showRegisterButton ?
                <div
                  className={classNames('d-fl ai-c', styles.footer_button)}
                  onClick={() => router.push(PATHS.REGISTER)}
                >
                  <p className={styles.footer_btn_text}>{t('homepage.sport.bottom.blue.button')}</p>
                  <IconArrowRight customClass={styles.footer_btn_icon} />
                </div>
              : null}
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      {sportsbook?.jsParams?.libraryUrl ? (
        <Script
          key={`sportsbook-${scriptLoaded}`}
          id="betby-renderer"
          async
          strategy="afterInteractive"
          src={sportsbook?.jsParams?.libraryUrl}
          onLoad={() => {
            setScriptLoaded(true);
          }}
        ></Script>
      ) : null}
      <div className={styles.guesthome_container}>
        <section
          className={`${styles.header_container} ${
            navIsTransparent == false ? styles.header_container_colored : styles.header_container_transparent
          } d-fl ai-c jc-sb`}
        >
          <GuestHeader player_type={player_type} />
        </section>
        <section>
          <TopWelcomeBlockSport theme={theme} regtype={regType} sport_landing={sport_landing?.[0]} />
        </section>
        <div className={`${styles.payments_container} d-fl ai-c jc-c`} key={payment_methods?.length}>
          <Payments payment_methods={payment_methods} />
        </div>
        <div className={styles.landing_title_1}>
          <p className={`${styles.homepageTitles} ${styles.boostWinnings} d-fl fd-c`}>
            <Trans components={{}} transKeepBasicHtmlNodesFor>
              homepage.sport.title.before.future.games
            </Trans>
          </p>
        </div>

        <div className={styles.next_games_container}>
          <div id="sportsbook-container" key={sportsbook?.jsParams?.token}>
            <div className={styles.next_games_container_gradient}></div>
            <div id="betby" ref={sportsFrame}></div>
            {/* <BetbyLoadingChecker /> */}
          </div>
        </div>
        <div className={classNames(`jc-c`, styles.btn_show_all_container)}>
          <div className={styles.btn_show_all_events} onClick={() => router.push(PATHS.SPORTS)}>
            <p>{t('homepage.sport.button.before.future.games')}</p>
            <IconArrowRight customClass={styles.btn_show_all_events_icon} />
          </div>
        </div>
        <div className={styles.landing_title_2}>
          <p className={`${styles.homepageTitles} ${styles.boostWinnings} d-fl fd-c`}>
            <Trans components={{}} transKeepBasicHtmlNodesFor>
              homepage.sport.title.before.replay
            </Trans>
          </p>
        </div>
        <div className={styles.container_carousel_center}>
          <ReplayCarousel locale={router.locale} player_type={player_type} />
        </div>

        {bottomCardC?.length > 0 ? (
          <>
            <div className={styles.bottom_container_desktop}>
              <div className={styles.bottom_container_desktop_inner}>
                <div className={styles.bottom_container_logo}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="1079" height="100%" viewBox="0 0 1079 545" fill="none">
                    <path
                      opacity="0.2"
                      d="M1244.19 -512.554L1245.13 122.823L954.786 -341.28C894.231 -333.208 847.99 -324.814 787.435 -307.703C727.037 -290.592 683.941 -274.287 627.791 -250.396L603.411 301.2L294.661 -248.621C180.315 -173.557 89.2469 -103.498 0.380859 -3.57434L568.337 1006.47L929.463 906.551L959.033 344.462L1258.5 815.668L1619.63 715.744L1618.06 -451.696C1491.44 -492.375 1378.67 -505.774 1244.51 -512.392L1244.19 -512.554Z"
                      fill="#1F0A4D"
                    />
                  </svg>
                </div>
                <div className={styles.bottom_container_title}>
                  <div className={styles.landing_title_3_desktop}>
                    <p className={`${styles.homepageTitles_blue} ${styles.boostWinnings} d-fl fd-c`}>
                      <Trans components={{}} transKeepBasicHtmlNodesFor>
                        homepage.sport.title.before.promo
                      </Trans>
                    </p>
                  </div>
                </div>
                <div className={styles.bottom_container_card}>
                  {bottomCardC?.map((el, index) => {
                    return (
                      <BottomCard
                        key={el.title}
                        title={el.title}
                        subtitle={el.subtitle}
                        number={bottomCardC?.length == 1 ? null : el.number}
                        description={el.description}
                        buttonComponent={el.buttonComponent}
                        image={el.image}
                        palette="sport"
                      ></BottomCard>
                    );
                  })}
                </div>
                <div className={styles.bottom_container_button}>
                  <div
                    className={classNames(styles.btn_show_all_events, styles.btn_show_all_events_transparent)}
                    onClick={() => openPromoModal(EPromoSlugs.SPORT_BONUS, dispatch)}
                  >
                    <p>{t('homepage.sport.button.before.promo')}</p>
                    <IconArrowRight customClass={styles.btn_show_all_events_icon} />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.landing_title_3_mobile}>
              <p className={`${styles.homepageTitles} ${styles.boostWinnings} d-fl fd-c`}>
                <Trans components={{}} transKeepBasicHtmlNodesFor>
                  homepage.sport.title.before.promo
                </Trans>
              </p>
            </div>
            <div className={styles.bottom_container_mobile}>
              <div
                key={`welcome.package-${router?.locale}-${currentLanguage?.code}`}
                className={`${styles.bottom_container_cards} ${
                  bottomCardC?.length == 3
                    ? styles.bottom_container_cards_3
                    : bottomCardC?.length == 2
                    ? styles.bottom_container_cards_2
                    : ''
                }`}
              >
                {bottomCardC?.map((el, index) => {
                  return (
                    <BottomCard
                      key={el.title}
                      title={el.title}
                      subtitle={el.subtitle}
                      number={bottomCardC?.length == 1 ? null : el.number}
                      description={el.description}
                      buttonComponent={el.buttonComponent}
                      image={el.image}
                      palette="sport"
                    ></BottomCard>
                  );
                })}
              </div>
            </div>
          </>
        ) : null}
        <GuestHomepageSportFooterSlot />
      </div>
    </>
  );
};
export default GuestHomepageSport;
